import exportFromJSON from "export-from-json";

const ExportToExcel = (data, fileName, exportType = "csv") => {
  exportFromJSON({ data, fileName, exportType });
};

export default ExportToExcel;
export { ExportToExcel };
